import { Api } from '@estee/elc-service';

export interface IPersonalizationData {
    id: string;
    userPersonalizationData: string;
    tags: string[];
    userIdentifier: string;
    userIdentifierType: string;
    creationDate: string;
}

export interface IPersonalizationRequestData {
    userPersonalizationData: string;
    tags: string[];
    userIdentifier: string;
    userIdentifierType: string;
}

interface IPersonalizationResponse {
    data: IPersonalizationData;
}

export interface IPersonalizationGetDataResponse {
    data: IPersonalizationData[];
}

export class PersonalizationApiSdk extends Api {
    private apiBasePath: string = 'stardust-foundation-user-personalization-v0';

    public async createPersonalizationData(
        data: IPersonalizationRequestData
    ): Promise<IPersonalizationData> {
        const url = `/${this.apiBasePath}/userPersonalizationData/`;

        const response: IPersonalizationResponse = await this.post({
            url,
            body: data
        });

        return response.data;
    }

    public async getPersonalizationDataByPerlgemUserId(
        fields: string[],
        perlgemId: string
    ): Promise<IPersonalizationData[]> {
        const url = `/${this.apiBasePath}/userPersonalizationData/perlgem_user_id/${perlgemId}`;

        const response: IPersonalizationGetDataResponse = await this.post({
            url,
            body: { fields }
        });

        return response.data;
    }

    public async deletePersonalizationDataByPerlgemUserId(perlgemId: string) {
        const url = `/${this.apiBasePath}/userPersonalizationData/perlgem_user_id/${perlgemId}`;

        const response = await this.delete({ url });

        return response.data;
    }
}
